import { FC, useEffect, useState } from 'react';
import { Flex, Loader, Stack } from '@mantine/core';
import { IconMail } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import { CardContainer } from '../../cardContainer';
import { IListItemProps, ListItem } from '../../listItem';
import { ROUTES } from '@/containers/routes/constants';
import { useAppSelector } from '@/hooks/redux/redux';
import { isSaaS } from '@/lib/utils/access';
import { MailServerForm } from '@/containers/pages/filials/edit/components/tabs/mail-servers/components/serverForm';
import useHomeWidgetSlice from '@/store/homeWidget/useHomeWidgetSlice';
import { TEMPLATE_MAIL_SERVER } from '@/services/api/emailServerApiArea/types';

interface IMailSectionProps {
  filialId: number;
}

export const MailSection: FC<IMailSectionProps> = ({ filialId }) => {
  const { t } = useTranslation();
  const { Settings } = useAppSelector((state) => state.userInfo);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [{ data, isLoading }] = useHomeWidgetSlice().useMailWidget().useState();
  const { LoadServicesSection, LoadMailSection } = useHomeWidgetSlice().actions;

  const handleCreateServer = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    LoadMailSection(filialId);
  }, []);

  const update = () => {
    LoadServicesSection(filialId);
    LoadMailSection(filialId);
  };

  const safetyMenu: IListItemProps = {
    withCheck: false,
    items: [
      {
        name: t('filials.serverList'),
        link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.common.mailServers}`,
        badge: data?.length || 0
      },
      {
        name: t('filials.addServer'),
        openModal: handleCreateServer
      },
      ...(!isSaaS(Settings)
        ? [
            {
              name: t('filials.emailSetting'),
              link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.common.mailingSetup}`
            }
          ]
        : [])
    ]
  };

  return (
    <>
      <CardContainer sectionName={t('servers.title')} Icon={IconMail}>
        {isLoading ? (
          <Flex w="100%" align="center" justify="center">
            <Loader size="sm" />
          </Flex>
        ) : (
          <Stack gap="11px" sx={{ width: '100%' }}>
            <ListItem items={safetyMenu.items} withCheck={safetyMenu.withCheck} />
          </Stack>
        )}
      </CardContainer>
      {isModalOpen && (
        <MailServerForm
          mailServer={TEMPLATE_MAIL_SERVER.TEMPLATE_MAIL_SERVER_ENTITY}
          CustomerId={filialId}
          opened={isModalOpen}
          handleChange={update}
          handleClose={() => setIsModalOpen(false)}
          isEditing={false}
        />
      )}
    </>
  );
};
